import { Link } from "react-router-dom";
import { currentTheme } from "../lib/theme";

export function Logo({ compact = false, inverse = false }: { compact?: boolean; inverse?: boolean }) {
  // inverse always sits on a dark surface (login story panel), so it keeps
  // the white wordmark in both modes.
  const src = inverse ? "/brand/footer-logo.svg" : currentTheme() === "light" ? "/brand/logo-light.svg" : "/brand/logo.svg";
  return (
    <Link className={`brand ${compact ? "brand--compact" : ""} ${inverse ? "brand--inverse" : ""}`} to="/" aria-label="Home">
      <img src={src} alt="Adnuvio" />
    </Link>
  );
}
